// Helpers
function scrollToTarget(selector) {
  const target = document.querySelector(selector)
  if (target) {
    const headerHeight = document.querySelector('.header').clientHeight + 30
    const targetPosition = target.getBoundingClientRect().top
    const offsetPosition = targetPosition + window.scrollY - headerHeight

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else {
    console.warn(`Элемент "${selector}" не найден!`)
  }
}

function setBodyOverflow(setOverflow, addPaddingToElems = []) {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  if (setOverflow) {
    document.body.style.overflow = 'hidden'
    document.body.style.paddingRight = `${scrollbarWidth}px`
  } else {
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }

  if (addPaddingToElems.length) {
    addPaddingToElems.forEach((elem) => {
      if (setOverflow) {
        elem.style.paddingRight = `${scrollbarWidth}px`
      } else {
        elem.style.paddingRight = ''
      }
    })
  }
}


// Header
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  let lastScrollTop = window.scrollY;

  (function headerWatcher() {
    if (lastScrollTop > window.scrollY || window.scrollY === 0) {
      header.classList.add('header--show')
      document.body.classList.add('header-shown')
    } else if (lastScrollTop < window.scrollY && window.scrollY !== 0) {
      header.classList.remove('header--show')
      document.body.classList.remove('header-shown')
    }
    if (window.scrollY < 50) {
      header.classList.remove('header--bg')
    } else {
      header.classList.add('header--bg')
    }
    lastScrollTop = window.scrollY
    requestAnimationFrame(headerWatcher)
  })()
})

// Menu
document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu
  const menu = document.querySelector('.mobile-menu')

  const closeMobileMenu = (() => {
    if(document.body.classList.contains('menu-opened')) {
      document.body.classList.remove('menu-opened')
      setBodyOverflow(false, [header])
      setTimeout(() => {
        menu.style.display = ''
      }, 300)
    }
  })

  const openMobileMenu = (() => {
    menu.style.display = 'flex'
    setTimeout(() => {
      document.body.classList.add('menu-opened')
      setBodyOverflow(true, [header])
    }, 10)
  })

  const mobileMenuActionBtn = document.querySelector('.mobile-menu__action-btn')
  if (mobileMenuActionBtn) {
    mobileMenuActionBtn.addEventListener('click', () => {
      closeMobileMenu()
    })
  }

  const menuBtn = document.querySelector('.header__menu-btn')
  const header = document.querySelector('.header')

  menuBtn.addEventListener('click', () => {
    if (document.body.classList.contains('menu-opened')) {
      closeMobileMenu()
    } else {
      openMobileMenu()
    }
  })

  window.addEventListener('resize', () => {
    closeMobileMenu()
  })

  // Nav
  const navLinkList = document.querySelectorAll('.mobile-menu__nav-link, .header__nav-link')
  if (navLinkList.length) {
    navLinkList.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        closeMobileMenu()
        const target = link.getAttribute('href').toString()
        scrollToTarget(target)
      })
    })
  }
})

// Modals
// Open modal
const openModal = (modalId) => {
  const page = document.querySelector('.page')
  const header = document.querySelector('.header')
  const modal = document.querySelector(modalId)
  const otherShownModal = document.querySelector('.modal--show')

  if (!modal) {
    console.warn(`Modal ${modalId} does not exist!`)
    return
  }

  if(modal.classList.contains('modal-fullscreen')) {
    initSliders()
  }

  modal.style.display = 'flex'
  setBodyOverflow(true, [header])

  if (otherShownModal) {
    closeModal(otherShownModal)
    setBodyOverflow(true, [header])
  } else {
    if(!modal.classList.contains('modal-fullscreen')) {
      page.classList.add('page--blur')
    }
  }

  const modalGrid = modal.querySelector('.modal-fullscreen__grid')

  setTimeout(() => {
    modal.classList.add('modal--show')
    if (modalGrid) {
      setTimeout(()=>{
        modalGrid.scrollTop = 0;
      })
    }
  })
}

// Close modal
const closeModal = (isModalFromModal = false) => {
  const page = document.querySelector('.page')
  const header = document.querySelector('.header')
  const modal = document.querySelector('.modal--show')
  if (!modal) return

  modal.classList.remove('modal--show')
  setBodyOverflow(false, [header])
  setTimeout(() => {
    modal.style.display = ''

    if (!isModalFromModal) {
      page.classList.remove('page--blur')
    }
  }, 350, modal)
}

document.addEventListener('DOMContentLoaded', () => {
  const modalLinks = document.querySelectorAll('[data-modal]')

  if (modalLinks.length) {
    modalLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const modalId = `#modal-${link.dataset.modal}`
        openModal(modalId)
        return false
      })
    })
  }

  // Close on Close btn click
  const closeButtons = document.querySelectorAll('.js-close-modal')
  if (closeButtons.length) {
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeModal())
    })
  }

  // Close on Escape
  document.body.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      closeModal()
    }
  }, false)
})

// modal fullscreen
let navSlider = null;
let mainSlider = null;

function initSliders() {
  // Уничтожаем старые слайдеры, если они существуют
  if (navSlider) {
    navSlider.destroy(true, true);
  }
  if (mainSlider) {
    mainSlider.destroy(true, true);
  }

  // Инициализируем навигационный слайдер
  navSlider = new Swiper('.modal-fullscreen__nav-slider-el', {
    slidesPerView: 5,
    spaceBetween: 8,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.modal-fullscreen__nav-slider-btn--next',
      prevEl: '.modal-fullscreen__nav-slider-btn--prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 6,
        spaceBetween: 10,
      }
    }
  });

  // Инициализируем основной слайдер
  mainSlider = new Swiper('.modal-fullscreen__main-slider-el', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.modal-fullscreen__main-slider-btn--next',
      prevEl: '.modal-fullscreen__main-slider-btn--prev',
    },
    thumbs: {
      swiper: navSlider,
    },
    on: {
      slideChange: function () {
        navSlider.slideTo(this.activeIndex);
      },
    },
  });

  navSlider.on('click', function () {
    const clickedIndex = navSlider.clickedIndex;
    mainSlider.slideTo(clickedIndex);
  });
}

// Forms
document.addEventListener('DOMContentLoaded', function () {
  const formList = document.querySelectorAll('.form')
  if (formList.length) {
    formList.forEach((form) => {
      // phone mask
      const inputTel = form.querySelector('input[type="tel"]')
      let phoneMask;
      if (inputTel) {
        phoneMask = IMask(
          inputTel, {
            mask: '+{7}(000) 000-00-00',
            placeholder: '_',
            lazy: true,
          }
        )
      }

      form.addEventListener('submit', (e) => {
        e.preventDefault()

        /* ---валидация--- */
        let canSubmit = true
        if (phoneMask.unmaskedValue.length !== 11) {
          canSubmit = false
          inputTel.focus()
        }
        if (!canSubmit) return false;
        /* ---валидация--- */

        //-------------
        // do something
        //-------------
        openModal('#modal-success')
        form.reset()
      })
    })
  }
})

// Section Options
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.section-options__slider')

  if (slider) {
    new Swiper(slider,
      {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }
      }
    )
  }
})

// Section Steps
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.section-steps')

  if (section) {
    const videBoxList = section.querySelectorAll('.section-steps__video-box')
    videBoxList.forEach((box) => {
      const playButton = box.querySelector('.section-steps__video-btn')
      const video = box.querySelector('.section-steps__video')

      const circle = box.querySelector('.section-steps__video-progress-circle');

      const radius = circle.r.baseVal.value;
      const circumference = 2 * Math.PI * radius;

      circle.style.strokeDashoffset = circumference;

      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = circumference;

      video.addEventListener('timeupdate', function () {
        const progress = video.currentTime / video.duration;

        circle.style.strokeDashoffset = circumference - progress * circumference

        if (video.ended) {
          circle.style.strokeDashoffset = circumference;
          box.classList.remove('section-steps__video-box--active')
        }
      });

      playButton.addEventListener('click', function () {
        if (video.paused) {
          try {
            video.play()
            box.classList.add('section-steps__video-box--active')
          } catch (err) {
            console.error("Ошибка воспроизведения:", err)
            box.classList.remove('section-steps__video-box--active')
          }
        } else {
          video.pause()
          video.currentTime = 0
          box.classList.remove('section-steps__video-box--active')
        }
      });
    })
  }
})

// Section Team
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.section-team__slider')

  if (slider) {
    new Swiper(slider.querySelector('.section-team__slider-el'),
      {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: slider.querySelector('.slider-nav__btn--next'),
          prevEl: slider.querySelector('.slider-nav__btn--prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          }
        }
      }
    )
  }
})

// Section Faq
document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq__item');

  faqItems.forEach(item => {
    const header = item.querySelector('.faq__header');
    const toggle = item.querySelector('.faq__toggle');

    header.addEventListener('click', () => {
      const isActive = item.classList.contains('faq__item--active');

      faqItems.forEach(faqItem => {
        faqItem.classList.remove('faq__item--active');
        const panel = faqItem.querySelector('.faq__panel');
        const toggleBtn = faqItem.querySelector('.faq__toggle');

        panel.setAttribute('aria-hidden', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
      });

      if (!isActive) {
        item.classList.add('faq__item--active');
        const panel = item.querySelector('.faq__panel');
        const toggleBtn = item.querySelector('.faq__toggle');

        panel.setAttribute('aria-hidden', 'false');
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

// Section Other
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.section-other__slider')

  if (slider) {
    new Swiper(slider.querySelector('.section-other__slider-el'),
      {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: slider.querySelector('.slider-nav__btn--next'),
          prevEl: slider.querySelector('.slider-nav__btn--prev'),
        },
        pagination: {
          el: slider.querySelector('.swiper-pagination-progressbar'),
          type: 'progressbar',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }
      }
    )
  }
})

// Section Reviews
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.section-reviews__list-btn').addEventListener('click', function() {
    const hiddenBlocks = document.querySelectorAll('.section-reviews__card--hidden');

    if (hiddenBlocks.length > 0) {
      // Показываем первые 2 скрытых блока
      const blocksToShow = Math.min(2, hiddenBlocks.length);

      for (let i = 0; i < blocksToShow; i++) {
        setTimeout(() => {
          hiddenBlocks[i].style.display='block'
          setTimeout(() => {
            hiddenBlocks[i].classList.remove('section-reviews__card--hidden')
            hiddenBlocks[i].style.opacity = 1;
            hiddenBlocks[i].style.transform = 'translateY(0)';
          }, 30);
        }, i * 150);
      }

      if (hiddenBlocks.length <= blocksToShow) {
        this.style.display = 'none';
      }
    }
  });
})